export default (axios, alert) => ({
  startIdent (request) {
    return axios.post('/customer/ident', request).then(({ data }) => data)
  },
  startPartnerIdent (request) {
    return axios.post('/customer/partner_ident', request).then(({ data }) => data)
  }
})
